// @ts-expect-error - imported from .js/.jsx file
import {EmailIcon} from 'shells/icon/svg/email-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TeamIcon} from 'shells/icon/svg/team-icon';

export const USER_TEMPLATES = 'userTemplates';
export const SHARED_TEMPLATES = 'sharedTemplates';
export const ARCHIVED_TEMPLATES = 'archivedTemplates';

export type SequenceTemplateType = 'userTemplates' | 'sharedTemplates' | 'archivedTemplates';

export type EmptyStateIcon = EmailIcon | TeamIcon;

type SequenceTemplateConstantsMap = {
    helperText?: string;
    emptyStateText?: string;
    emptyStateSubText?: string;
    emptyStateIcon?: EmptyStateIcon;
    shouldShowCreator: boolean;
};

const sequenceTemplateConstants: Partial<
    Record<SequenceTemplateType, SequenceTemplateConstantsMap>
> = {
    [USER_TEMPLATES]: {
        emptyStateText: 'You haven’t created any templates.',
        emptyStateSubText: 'Automate email from Nutshell with your own personalized templates.',
        emptyStateIcon: EmailIcon,
        shouldShowCreator: false,
    },
    [SHARED_TEMPLATES]: {
        emptyStateText: 'Your teammates haven’t shared any templates.',
        emptyStateSubText:
            'When your team creates and shares their templates, they’ll show up here.',
        emptyStateIcon: TeamIcon,
        shouldShowCreator: true,
    },
    [ARCHIVED_TEMPLATES]: {
        shouldShowCreator: false,
    },
};

export function shouldShowEmptyStateForType(templateType: SequenceTemplateType): boolean {
    // @ts-expect-error
    return sequenceTemplateConstants[templateType].emptyStateText !== undefined;
}

export function getEmptyStateTextForType(
    templateType: SequenceTemplateType
): string | null | undefined {
    // @ts-expect-error
    return sequenceTemplateConstants[templateType].emptyStateText;
}

export function getEmptyStateSubTextForType(
    templateType: SequenceTemplateType
): string | null | undefined {
    // @ts-expect-error
    return sequenceTemplateConstants[templateType].emptyStateSubText;
}

export function getEmptyStateIconForType(
    templateType: SequenceTemplateType
): EmptyStateIcon | null | undefined {
    // @ts-expect-error
    return sequenceTemplateConstants[templateType].emptyStateIcon;
}

export function shouldShowCreatorForType(templateType: SequenceTemplateType): boolean {
    // @ts-expect-error
    return sequenceTemplateConstants[templateType].shouldShowCreator;
}
